<template>
  <a-layout>
    <a-layout-content style="background-color:white">
      <a-row class="vd-toolbar">
        <a-col class="vd-toolbar-right vd-bar">
          <a-form layout="inline">
            <a-form-item label="姓名">
              <a-input placeholder="推广员姓名" />
            </a-form-item>
            <a-form-item label="编号">
              <a-input placeholder="推广员编号" />
            </a-form-item>
            <a-form-item>
              <a-button type="primary" icon="search" />
            </a-form-item>
          </a-form>
        </a-col>
      </a-row>
      <a-table row-key="id" :data-source="list" :pagination="pagination">
        <a-table-column title="ID" data-index="id" />
        <a-table-column-group align="center" title="推广人">
          <a-table-column align="center" title="用户名" data-index="agent" />
          <a-table-column align="center" title="地区" data-index="area" />
        </a-table-column-group>
        <a-table-column align="center" title="收集信息" data-index="mobile" />
        <a-table-column align="center" title="收集时间" data-index="add_time">
          <template scope="text">
            {{ $FormatUtil.timestamp2date(text) }}
          </template>
        </a-table-column>
      </a-table>
    </a-layout-content>
  </a-layout>
</template>

<script>
import { book_info } from "@/api/book";

export default {
  name: "DetailMember",
  data() {
    return {
      id: 0,
      list: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        onChange: (page) => {
          this.pagination.current = page;
        },
      },
      loading: {
        size: "large",
        spinning: false,
      },
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getData();
  },
  methods: {
    getData() {
      book_info({
        activity_id: this.id,
      }).then((res) => {
        console.log(res);
        if (res["code"] === 1) {
          this.list = res.list;
          this.$message.success("获取成功");
        } else {
          this.$message.warning(res["msg"]);
        }
      });
    },
  },
};
</script>

<style scoped></style>
